import ResetPassword from "../../componets/ContainerLogin/ResetPassword";

export default function ResetPasswordPage() {
  return <ResetPassword />;
}

